import routes from './app.routes';
import init from './init';

init(routes);
